// @ts-nocheck
import axios from 'axios';
import { APP_CONFIG } from '@/constants';
import { exceptionInterceptor } from '@/interceptors/exceptionInterceptor';

/**
 * Token getter injected from Vue (Clerk lives there)
 * @type {(() => Promise<string | null>) | null}
 */
let tokenGetter = null;

/**
 * Called once from Vue to inject Clerk's getToken
 * @param {() => Promise<string | null>} fn
 */
export function setTokenGetter(fn) {
  tokenGetter = fn;
}

/**
 * @param {Object} [options]
 * @param {boolean} [options.useExceptionInterceptor]
 * @returns {Promise<import('axios').AxiosInstance>}
 */
export default async (options = {}) => {
  const { useExceptionInterceptor = true } = options || {};

  let token = null;
  try {
    token = tokenGetter ? await tokenGetter() : null;
  } catch (e) {
    console.error('Failed to get auth token:', e);
  }

  const http = axios.create({
    baseURL: APP_CONFIG.apiUrl,
    withCredentials: true,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  if (useExceptionInterceptor) {
    http.interceptors.response.use(null, exceptionInterceptor);
  }

  return http;
};
